import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import "./index.css";

import App from "./App";
import GroupCover from "./components/GroupCover";
import NotFound from "./components/NotFound";
import PrivacyPolicy from "./components/PrivacyPolicy";
import TermsOfService from "./components/TermsOfService";
import { AuthProvider, useAuth } from "./dashboard/AuthContext";
import Login from "./dashboard/Login";
import Signup from "./dashboard/Signup";
import Dashboard from "./dashboard/Dashboard";
import V5Shell from "./v5/V5Shell";
import Entry from "./v5/pages/Entry";
import Home from "./v5/pages/Home";
import Products from "./v5/pages/Products";
import ProductPage from "./v5/pages/ProductPage";

/* ─── Route guard for /dashboard ──────────────────────── */
function RequireAuth({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return null; // dashboard's own loader will paint after auth resolves
  if (!user) return <Navigate to="/login" replace state={{ from: location }} />;
  return children;
}

/* ─── Top-level route table ───────────────────────────── */
function Root() {
  return (
    <Routes>
      {/* V5: loader → entry → chapters. One shell owns loader, nav and transitions. */}
      <Route element={<V5Shell />}>
        <Route path="/" element={<Entry />} />
        <Route path="/home" element={<Home />} />
        <Route path="/products" element={<Products />} />
        <Route path="/products/:slug" element={<ProductPage />} />
      </Route>
      {/* V4 (previous site) kept reachable while V5 beds in. Remove when ready. */}
      <Route path="/v4" element={<App />} />
      <Route path="/v4/cover" element={<GroupCover />} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/terms" element={<TermsOfService />} />
      <Route path="/login"  element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/dashboard" element={<RequireAuth><Dashboard /></RequireAuth>} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <Root />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
